var toString = Object.prototype.toString;


module.exports = function isNumber(obj) {
    return toString.call(obj) === '[object Number]';
};



// WEBPACK FOOTER //
// ./~/amp-is-number/is-number.js